var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "alarm-log-category-chart"
  }, [_c('div', {
    staticStyle: {
      "position": "relative",
      "max-width": "inherit",
      "max-height": "250px"
    }
  }, [_c('core-chart-chart-js-doughnut', {
    staticStyle: {
      "max-width": "250px",
      "max-height": "250px"
    },
    attrs: {
      "datasets": _vm.datasets,
      "labels": _vm.labels,
      "options": _vm.options
    }
  })], 1), _c('div', {
    staticStyle: {
      "margin-left": "16px"
    }
  }, [_c('ul', {
    staticClass: "chart-legend"
  }, _vm._l(_vm.categoryColorMap, function (color, label, idx) {
    return _c('li', {
      key: idx
    }, [_c('div', {
      staticClass: "color-block",
      style: `background: ${color};`
    }), _c('span', [_vm._v(_vm._s(_vm.$i18n_t(`AlarmLogs.categories.${label}`)) + " - " + _vm._s(_vm.legendCount[idx]))])]);
  }), 0)])]);
};
var staticRenderFns = [];
export { render, staticRenderFns };